import React from 'react';

import AboutDescription from './WhatWeDoPartials/AboutDescription';
import InfoBox from './WhatWeDoPartials/AboutInfoBox';
import OptimizedImage from '../../OptimizedImage';

const About = () => {
  return (
    <OptimizedImage
      src="pages/software-services/whatwedo_bg.png"
      background
      style={{
        backgroundSize: '50%',
        backgroundPosition: 'top 0 right 0'
      }}
    >
      <div className="container">
        <div className="bg-beam">
          <AboutDescription />
          <InfoBox />
        </div>
      </div>
    </OptimizedImage>
  );
};

export default About;
